import { XMLParser, XMLValidator } from "fast-xml-parser";
import { v4 as uuidv4 } from "uuid";

export const XmlToJson = (data) => {
  const options = {
    attributeNamePrefix: "@_",
    ignoreAttributes: false,
    ignoreNameSpace: false,
    allowBooleanAttributes: true,
    parseNodeValue: true,
    parseAttributeValue: false,
    trimValues: true,
    parseTrueNumberOnly: false,
    arrayMode: false,
  };

  const xmlData = data.replace(/^\uFEFF/g, "").replace(/^\u00EF?\u00BB\u00BF/g, ""); // For Removing BOM from XMl

  if (XMLValidator.validate(xmlData) == true) {
    const parser = new XMLParser(options);
    return parser.parse(xmlData);
  }

  return "Invalid XML data";
};

export const convertXmlDataToTasks = (dataArray, scheduleId) => {
  const customTaskIdAndmySqlIdMapper = {};
  const customTaskIdAndhasChildMapper = {};

  const finalData = dataArray.map((data, index) => {
    const uniqueId = uuidv4();
    customTaskIdAndmySqlIdMapper[data.TaskId] = uniqueId;
    if (data.WBSPath != "") {
      customTaskIdAndhasChildMapper[data.WBSPath] = true;
    }

    return {
      scheduleCounter: index + 1,
      mysqlId: uniqueId,
      isDeleted: false,
      title: data.TaskName,
      tags: [],
      taskHasTasks: [],
      taskHasFiles: [],
      taskAssignedTo: [],
      taskHasIssues: [],
      taskHasResources: [],
      taskTypeId: null,
      taskTypeData: {},
      selectionSet: [],
      customTaskId: data.TaskId ?? null,
      startDate: data.Start ? new Date(data.Start).getTime() : null,
      endDate: data.Finish ? new Date(data.Finish).getTime() : null,
      description: "",
      typeId: null,
      scheduleId,
      hasChild: false,
      parentId: null,
      actualStartDate: data.ActualStart ? new Date(data.ActualStart).getTime() : null,
      actualEndDate: data.ActualFinish ? new Date(data.ActualFinish).getTime() : null,
      plannedStartDate: data.PlannedStart ? new Date(data.PlannedStart).getTime() : null,
      plannedEndDate: data.PlannedFinish ? new Date(data.PlannedFinish).getTime() : null,
      progress: data.Progress ? data.Progress : "0",
      predecessor: data.PredecessorDetails ?? "",
      parentName: data.WBSPath ?? "",
      status: "",
      duration: data.Duration ?? 0,
      WBSCode: data.WBSCode ?? null,
      critical: data.critical ?? "No",
      totalSlack: data.totalSlack ?? 0,
    };
  });

  finalData.map((data) => {
    if (data.parentName != "") {
      data.parentId = customTaskIdAndmySqlIdMapper[data.parentName];
      if (customTaskIdAndhasChildMapper[data.customTaskId]) {
        data.hasChild = customTaskIdAndhasChildMapper[data.customTaskId];
      }
    }
  });

  return finalData;
};
